import { styled } from "@mui/material/styles";
import {
    Avatar,
    IconButton,
    ListItemAvatar,
    ListItemButton,
    Typography,
} from "@mui/material";
import { TEXT_ELLIPSIS } from "../../../../Shared/styles";

export const ListItemButtonContainer = styled(ListItemButton)({
    alignItems: "center",
    padding: "4px 0",
    "&:hover": {
        backgroundColor: "transparent",
    },
    ".MuiListItemSecondaryAction-root": {
        right: 0,
        padding: 0,
    },
});

export const ListItemTextHeadline = styled(Typography)({
    fontSize: "14px",
    fontWeight: "700",
    color: "var(--community-color-primary-text)",
    paddingRight: "60px",
    ...TEXT_ELLIPSIS,
});

export const ListItemIconButton = styled(IconButton)({
    color: "var(--community-color-secondary-text)",
    padding: 0,
});

export const AvatarStyled = styled(Avatar)({
    width: "32px",
    height: "32px",
});

export const ListItemAvatarContainer = styled(ListItemAvatar)({
    width: "32px",
    height: "32px",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    marginRight: "8px",
    minWidth: "32px",
});
